import { Alert } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  resolveChecklistColor,
  resolveChecklistIcon,
} from 'src/Components/Checklists/checklistVisuals.helper';
import { ChecklistSubmissionForm } from 'src/Components/Forms/ChecklistSubmission/ChecklistSubmissionForm';
import { FullScreenFormWrapper } from 'src/Containers/FullScreenFormWrapper';
import { useSubmitChecklistForm } from 'src/Hooks/Forms/useSubmitChecklist';
import { useSubmitExportedChecklist } from 'src/Hooks/Mutations/useSubmitExportedChecklist';
import useFetchExport from 'src/Hooks/Queries/useFetchExport';
import useFetchExportedChecklist from 'src/Hooks/Queries/useFetchExportedChecklist';

import styles from './ExportChecklistPage.module.scss';
import { Props } from './ExportChecklistPage.types';

const ExportChecklistPage = ({ token }: Props) => {
  const { data: exportData } = useFetchExport(token);
  const { data: checklist } = useFetchExportedChecklist({
    token,
    checklistId: exportData?.entityIds?.[0],
  });
  const { mutate } = useSubmitExportedChecklist({ onSuccess: () => setSubmitted(true) });

  const form = useSubmitChecklistForm();
  const { t } = useTranslation();

  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (checklist) {
      form.setValues({
        items: checklist.items.map(item => ({
          checklistItemId: item.id,
          isChecked: false,
        })),
      });
    }
  }, [checklist, exportData]);

  const Icon = resolveChecklistIcon(checklist?.icon);
  const color = resolveChecklistColor(checklist?.color);

  return (
    <FullScreenFormWrapper maxWidth={400}>
      <div className={styles.titleGroup}>
        {checklist && (
          <div className={styles.iconBadge} style={{ backgroundColor: `${color}1f` }}>
            <Icon size={20} color={color} />
          </div>
        )}
        <div className={styles.title}>{checklist?.title}</div>
      </div>
      {submitted ? (
        <div className={styles.submittedContainer}>
          <Alert>{t('checklist.export.submitted', 'Checklist soumise avec succès !')}</Alert>
        </div>
      ) : (
        <ChecklistSubmissionForm
          form={form}
          onSubmit={form.onSubmit(values => {
            mutate({ token, checklist: values, checklistId: exportData?.entityIds?.[0] ?? '' });
          })}
          submitButtonLabel={t('checklist.form.submitAnswers', 'Soumettre les réponses')}
          checklist={checklist}
        />
      )}
    </FullScreenFormWrapper>
  );
};

export default ExportChecklistPage;
